import { render, staticRenderFns } from "./DisplayServices.vue?vue&type=template&id=4b545615&scoped=true&"
import script from "./DisplayServices.vue?vue&type=script&lang=js&"
export * from "./DisplayServices.vue?vue&type=script&lang=js&"
import style0 from "./DisplayServices.vue?vue&type=style&index=0&id=4b545615&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b545615",
  null
  
)

export default component.exports